module.exports = __webpack_public_path__ + "img/underReview2x.fbfbe110.png";